import { Link, useParams } from 'react-router-dom';
import { useState } from 'react';
import { categories, getDramasByCategory, type Drama } from '@/mocks/dramas';
import DramaCard from './DramaCard';

export default function CategorySection() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || 'all');
  const [visibleCount, setVisibleCount] = useState(8);

  const filteredDramas = getDramasByCategory(activeCategory);

  const handleCategoryChange = (catSlug: string) => {
    setActiveCategory(catSlug);
    setVisibleCount(8);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleLoadMore = () => {
    setVisibleCount((prev) => Math.min(prev + 8, filteredDramas.length));
  };

  const visibleDramas = filteredDramas.slice(0, visibleCount);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              剧集分类
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              按类型筛选，找到你想看的剧
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 overflow-x-auto pb-2 mb-8 scrollbar-hide flex-wrap">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              onClick={(e) => {
                e.preventDefault();
                handleCategoryChange(cat.slug);
              }}
              className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-300'
              }`}
            >
              <i className={`${cat.icon} text-base`}></i>
              {cat.name}
            </Link>
          ))}
        </div>

        {visibleDramas.length > 0 ? (
          <>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
              {visibleDramas.map((drama) => (
                <DramaCard key={drama.slug} drama={drama} />
              ))}
            </div>

            {visibleCount < filteredDramas.length && (
              <div className="flex justify-center mt-10">
                <button
                  onClick={handleLoadMore}
                  className="px-8 py-2.5 rounded-full bg-background-100 hover:bg-background-200 text-foreground-700 text-sm font-medium border border-background-300 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  加载更多 ({filteredDramas.length - visibleCount} 部)
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
              <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
            </div>
            <p className="text-foreground-500 text-sm">该分类暂无剧集</p>
          </div>
        )}
      </div>
    </section>
  );
}